import React from 'react';
import PropTypes from 'prop-types';

import { LightBox } from '@sm360/widget-commons-general';

class LightboxCarrousel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentImageIndex: props.imageIndex,
        };

        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
        this.openLightBox = this.openLightBox.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (this.props === newProps) {
            return;
        }

        this.setState({
            currentImageIndex: newProps.imageIndex,
        });
    }

    // TODO: #improvement - Check if this method is still relevant/necessary
    openLightBox(index, event) {
        event.preventDefault();
        this.setState({
            currentImageIndex: index,
        });
    }

    gotoPrevious() {
        this.setState((prevState) => {
            const prevIndex =
                prevState.currentImageIndex > 0 ? prevState.currentImageIndex - 1 : this.props.pictures.length - 1;
            return { currentImageIndex: prevIndex };
        });
    }

    gotoNext() {
        this.setState((prevState) => {
            const nextIndex =
                prevState.currentImageIndex < this.props.pictures.length - 1 ? prevState.currentImageIndex + 1 : 0;
            return { currentImageIndex: nextIndex };
        });
    }

    render() {
        const { pictures, toggleLightBox } = this.props;
        const { currentImageIndex } = this.state;
        const lightBoxImages = pictures.map((image) => image.src);
        const nextImageIndex = currentImageIndex < pictures.length - 1 ? currentImageIndex + 1 : 0;
        const prevImageIndex = currentImageIndex > 0 ? currentImageIndex - 1 : pictures.length - 1;

        return (
            <LightBox
                mainSrc={lightBoxImages[currentImageIndex]}
                nextSrc={lightBoxImages[nextImageIndex]}
                prevSrc={lightBoxImages[prevImageIndex]}
                onCloseRequest={toggleLightBox}
                onMovePrevRequest={this.gotoPrevious}
                onMoveNextRequest={this.gotoNext}
                enableZoom={false}
            />
        );
    }
}

LightboxCarrousel.defaultProps = {
    pictures: [],
};

LightboxCarrousel.propTypes = {
    imageIndex: PropTypes.number.isRequired,
    pictures: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string,
        })
    ),
    toggleLightBox: PropTypes.func.isRequired,
};

LightboxCarrousel.displayName = 'LightboxCarrousel';

export default LightboxCarrousel;
